import { ApprovingInvoiceReportsSearchRefetch } from '@/context/services/approving_invoice_reports/type';
import { FC, PropsWithChildren, createContext, useContext } from 'react';

const ApprovingInvoiceReportsSearchContext = createContext<
  ApprovingInvoiceReportsSearchRefetch | undefined
>(undefined);

type TValue<T extends Function> = {
  value: T;
};

export const ApprovingInvoiceReportsSearchRefetchProvider: FC<
  PropsWithChildren<TValue<ApprovingInvoiceReportsSearchRefetch>>
> = ({ children, value }) => {
  return (
    <ApprovingInvoiceReportsSearchContext.Provider value={value}>
      {children}
    </ApprovingInvoiceReportsSearchContext.Provider>
  );
};

export const useApprovingInvoiceReportsSearchRefetch = ():
  | ApprovingInvoiceReportsSearchRefetch
  | undefined => useContext(ApprovingInvoiceReportsSearchContext);
